export default __webpack_public_path__ + "b7abc7bff117ce954ba179065ead5c0f.png";